module.exports = __webpack_public_path__ + "static/Image_2A-695825b9d715c0271d8375abf879ac18.png";